import React from "react";
import Box from "@mui/material/Box";

const reducedMotion = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        "&::after": { animation: "none" },
    },
};

export function ShopHeroIcon({ children, tone = "gold" }) {
    const gold = tone === "gold";
    return (
        <Box
            sx={{
                width: 76,
                height: 76,
                mb: 1.5,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: gold ? "#fef3c7" : "#e0f2fe",
                boxShadow: gold
                    ? "0 0 0 8px rgba(251, 191, 36, 0.18), 0 8px 20px rgba(217, 119, 6, 0.28)"
                    : "0 0 0 8px rgba(14, 165, 233, 0.16), 0 8px 20px rgba(14, 116, 144, 0.22)",
                animation: "wwShopBounce 1.6s ease-in-out infinite",
                "@keyframes wwShopBounce": {
                    "0%, 100%": { transform: "translateY(0) scale(1)" },
                    "50%": { transform: "translateY(-5px) scale(1.06)" },
                },
                ...reducedMotion,
            }}
        >
            {children}
        </Box>
    );
}

const shineAfter = {
    content: "\"\"",
    position: "absolute",
    inset: 0,
    background: "linear-gradient(105deg, transparent 30%, rgba(255,255,255,0.45) 50%, transparent 70%)",
    transform: "translateX(-120%)",
    animation: "wwCtaShine 2.2s ease-in-out infinite",
};

export const goldCtaSx = {
    minHeight: 52,
    borderRadius: 999,
    fontWeight: 800,
    fontSize: "1.05rem",
    letterSpacing: "0.02em",
    textTransform: "none",
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(180deg, #fbbf24 0%, #d97706 100%)",
    boxShadow: "0 8px 18px rgba(217, 119, 6, 0.38)",
    animation: "wwGoldGlow 1.8s ease-in-out infinite",
    "@keyframes wwGoldGlow": {
        "0%, 100%": { boxShadow: "0 8px 18px rgba(217, 119, 6, 0.38)" },
        "50%": { boxShadow: "0 10px 26px rgba(251, 191, 36, 0.7)" },
    },
    "&::after": shineAfter,
    "@keyframes wwCtaShine": {
        "0%": { transform: "translateX(-120%)" },
        "60%, 100%": { transform: "translateX(120%)" },
    },
    "&:hover": {
        background: "linear-gradient(180deg, #fcd34d 0%, #b45309 100%)",
    },
    "&.Mui-disabled": { opacity: 0.65, color: "#fff" },
    ...reducedMotion,
};

export const greenCtaSx = {
    minHeight: 44,
    px: 2.25,
    borderRadius: 999,
    fontWeight: 800,
    textTransform: "none",
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(180deg, #4ade80 0%, #16a34a 100%)",
    boxShadow: "0 8px 16px rgba(22, 163, 74, 0.35)",
    animation: "wwGreenGlow 1.8s ease-in-out infinite",
    "@keyframes wwGreenGlow": {
        "0%, 100%": { boxShadow: "0 8px 16px rgba(22, 163, 74, 0.35)", transform: "scale(1)" },
        "50%": { boxShadow: "0 10px 24px rgba(74, 222, 128, 0.55)", transform: "scale(1.03)" },
    },
    "&::after": shineAfter,
    "@keyframes wwCtaShine": {
        "0%": { transform: "translateX(-120%)" },
        "60%, 100%": { transform: "translateX(120%)" },
    },
    "&:hover": {
        background: "linear-gradient(180deg, #86efac 0%, #15803d 100%)",
    },
    "&.Mui-disabled": { opacity: 0.65, color: "#fff" },
    ...reducedMotion,
};

export const closeCtaSx = {
    minHeight: 44,
    borderRadius: 999,
    fontWeight: 800,
    textTransform: "none",
    color: "#0e7490",
    "&:hover": { bgcolor: "rgba(14, 116, 144, 0.08)" },
};

export const goldShopPaperSx = {
    p: 2.5,
    width: 300,
    maxWidth: "calc(100vw - 32px)",
    borderRadius: 3,
    bgcolor: "#fffbeb",
    color: "#0c4a6e",
    border: "1px solid rgba(251, 191, 36, 0.55)",
    boxShadow: "0 18px 44px rgba(180, 83, 9, 0.28)",
    overflow: "visible",
};

export const tealShopPaperSx = {
    p: 2.5,
    width: 360,
    maxWidth: "calc(100vw - 32px)",
    borderRadius: 3,
    bgcolor: "#f0f9ff",
    color: "#0c4a6e",
    border: "1px solid rgba(14, 116, 144, 0.35)",
    boxShadow: "0 18px 44px rgba(14, 116, 144, 0.2)",
    overflow: "visible",
};
